import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { COMMON_TEXT } from '@/helpers/common-text';
import './FollowSection.less';

class FollowSection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const followedEmployeeIds = this.props.followedEmployeeIds || new Set();
    const followCount = followedEmployeeIds.size;
    const { isSelected, onClick } = this.props;

    return (
      <div className="follow-section">
        <div key={`group-follow`} className="group-section">
          <div className="group-header">
            <span className="group-name">{COMMON_TEXT.FOLLOW_SECTION_TITLE}</span>
          </div>
        </div>
        <div
          className={`team-row ${isSelected ? 'selected' : ''}`}
          onClick={onClick}
        >
          <span className="team-name">{COMMON_TEXT.FOLLOW_SECTION_TITLE}</span>
          <span className="team-count">{followCount}</span>
          <div className="arrow-icon-v3">
            <i className="pi pi-chevron-right" />
          </div>
        </div>
      </div>
    );
  }
}

FollowSection.propTypes = {
  followedEmployeeIds: PropTypes.instanceOf(Set).isRequired,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
};


export default FollowSection;
